import React, { ReactNode, ComponentProps } from 'react';
import { MDXProvider as BaseMDXProvider } from '@mdx-js/react';
import {
  BarChart, LineChart, PieChart, ChartGrid,
} from './Charts';

interface MDXProviderProperties {
  children: ReactNode;
}

const components = {
  BarChart,
  LineChart,
  PieChart,
  ChartGrid,
  table: (properties: ComponentProps<'table'>) => (
    <table {...properties} />
  ),
  th: (properties: ComponentProps<'th'>) => (
    <th {...properties} />
  ),
  td: (properties: ComponentProps<'td'>) => (
    <td {...properties} />
  ),
};

export const MDXProvider = ({ children }: MDXProviderProperties) => (
  <BaseMDXProvider components={components}>
    {children}
  </BaseMDXProvider>
);

export default MDXProvider;
